import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./lib/theme.jsx";
import { AuthProvider } from "./lib/auth.jsx";
import { UnitsProvider } from "./lib/units.jsx";
import App from "./App.jsx";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/hero.css";
import "./styles/today.css";
import "./styles/hud.css";
import "./styles/recap.css";
import "./styles/battery.css";
import "./styles/maintenance.css";
import "./styles/performance.css";
import "./styles/automations.css";
import "./styles/overview.css";
import "./styles/landing.css";
import "./styles/dnd.css";
import "./styles/reports.css";
import "./styles/planner.css";
import "./styles/security.css";
import "./styles/trail.css";
import "./styles/driving.css";
import "./styles/fsd.css";
import "./styles/trips.css";
import "./styles/charging.css";
import "./styles/community.css";
import "./styles/settings.css";
import "./styles/admin.css";
import "./styles/live.css";
import "./styles/dashcam.css";
import "./styles/car.css";
import "./styles/touch.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <UnitsProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </UnitsProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Global error reporting -> /client-errors (prod only, so dev noise stays out
// of the Admin Errors panel).
import { initErrorReporting } from "./lib/errorReport.js";
if (import.meta.env.PROD) initErrorReporting();

// Real-user web-vitals -> /client-vitals (prod only). Tagged with a device
// class so Tesla center-screen performance is measured, not assumed.
import { initVitals } from "./lib/vitals.js";
if (import.meta.env.PROD) initVitals();

// PWA: register the combined OneSignal + offline-cache service worker (prod
// only, so dev never serves stale chunks). OneSignal's SDK registers the same
// file/scope, so this is idempotent with push.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/OneSignalSDKWorker.js").catch(() => {});
  });
}
